import "./style.css";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import { getAsset } from "../../helpers/helper";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const Candidateshowmodal = ({ lgShow, setLgShow, coverletter, cvdata }) => {
  return (
    <>
      <Modal
        size="xl"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>
            <Col lg="5">
              <h2 className="text-center mb-5">Cover Letter</h2>
              <p className="mb-0 font_14 text-center" style={{ wordBreak: "break-word", fontWeight: "100" }}>
                {coverletter}
              </p>
            </Col>

            <Col lg="7">
              {cvdata && cvdata.trim() !== "" ? (
                <Worker
                  workerUrl={`https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js`}
                >
                  <div style={{ height: "600px", overflow: "auto" }}>
                    <Viewer fileUrl={getAsset(cvdata)} />
                  </div>
                </Worker>
              ) : (
                <div className="d-flex flex-column justify-content-center align-items-center h-100 mt-5 pt-5">
                  <h4 className="text-muted">No resume uploaded</h4>
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Candidateshowmodal;
